import React from 'react';
import $ from 'jquery';
import _ from 'lodash';
import Select from 'react-select';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { Col, Breadcrumb, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

const FileViewMode = (props) => {
    return (
        <a className="viewLink" href={props.fileURL !== undefined ? props.fileURL.file_path : ""} target="_blank">
            <div className="img" style={{ backgroundImage: `url(${props.fileURL !== undefined ? props.fileURL.thumbnail_path : ""})` }}></div>
            <span className="name">{props.file.file_name}</span>
            <span className="update_time">{props.file.update_time}</span>
        </a>
    );
}
/*
    file: 一般檢視模式
    點選該檔案會開新分頁
    顯示檔案名稱/更新日期
*/

const FileDeleteMode = (props) => {
    return (
        <div>
            <a className="deleteBtn" onClick={props.onClickDelete.bind(props.bindTarget, props.file.file_id)}>
                <span className="glyphicon glyphicon-trash"></span>
            </a>
            <div className="img deleteModeImg" style={{ backgroundImage: `url(${props.fileURL !== undefined ? props.fileURL.thumbnail_path : ""})` }}></div>
            <span className="name">{props.file.file_name}</span>
            <span className="update_time">{props.file.update_time}</span>
        </div>
    );
}
/*
    file: 刪除模式, css用filter:opacity(50%)
    點選右上角的垃圾桶就會進入AFile.deleteFile()
    沒有做"您是否確定要刪除該檔案"的彈出警示, 因為每刪一次就問一次應該會很煩吧!
*/

export class AFile extends React.Component {
    deleteFile(id) {
        let breadcrumbsMap = _.mapValues(this.props.breadcrumbs, 'name');
        let path_value = _.toArray(breadcrumbsMap).toString();
        let file_id = id;

        let formData = new FormData();
        formData.append('file_id', file_id);
        formData.append('path_value', path_value);//字串, 路徑的name, ex: root,folder1,folder2

        $.ajax({
            type: 'post',
            url: '/api/W_SaleSky_MediaCloud_Relation_DeleteWithFile.php',
            data: formData,
            processData: false,
            contentType: false,
            success: response => {
                if (response.status === "0") {//成功
                    $('#fileDiv' + this.props.file.file_id).hide();//成功刪除的當下先隱藏, 按下"完成"後再重刷頁面
                }
            },
            error: (xhr, ajaxOptions, thrownError) => { }
        });
    }
    render() {
        let {
            file,
            deleteMode,
        } = this.props;
        let fileURL = file.url;
        return (
            <Col sm={3} className="a_file" id={'fileDiv' + file.file_id}>
                {
                    !deleteMode ? /*檢視模式*/
                        <ContextMenuTrigger id={'fileDiv' + file.file_id} holdToDisplay={1000}> {/*一個triggerId對應到一個ContextMenuId*/}
                            <FileViewMode
                                fileURL={fileURL}
                                file={file} />
                        </ContextMenuTrigger>
                        :
                        <FileDeleteMode
                            fileURL={fileURL}
                            file={file}
                            bindTarget={this}
                            onClickDelete={this.deleteFile} /> /*刪除模式*/
                }
                <ContextMenu id={'fileDiv' + file.file_id}>
                    <MenuItem onClick={(event, file) => this.props.editFile(event, file)} data={{ file: file }}>編輯</MenuItem>
                </ContextMenu>
            </Col>
        );
        /*
            ContextMenuTrigger 點選右鍵顯示contextMenu
            要包裹在"欲點擊的物件"之外
            一個ContextMenuTrigger的id, 會對應到一個ContextMenu的id
        */
    }
}

const FolderViewMode = (props) => {
    /*
        folder: 一般檢視模式
        點選資料夾會進入MediaCloudCt的onClickFolder()
        顯示資料牙名稱/更新日期
    */
    return (
        <Col sm={3} className="a_folder" onClick={props.onClickFolder} >
            <div className="img" style={{ backgroundImage: `url(${"/imgs/folder.png"})` }}></div>
            <span className="name">{props.folder.name}</span>
            <span className="update_time">{props.folder.update_time}</span>
        </Col>
    );
}

const FolderDeleteMode = (props) => {
    /*
        folder: 刪除模式
        跟刪除file一樣
    */
    return (
        <div>
            <Col sm={3} className="a_folder">
                <a className="deleteBtn" onClick={props.deleteFolder.bind(props.bindTarget, props.folder.name)}>
                    <span className="glyphicon glyphicon-trash"></span>
                </a>
                <div className="img deleteModeImg" style={{ backgroundImage: `url(${"/imgs/folder.png"})` }}></div>
                <span className="name">{props.folder.name}</span>
                <span className="update_time">{props.folder.update_time}</span>
            </Col>
        </div>
    );
}

export class AFolder extends React.Component {
    deleteFolder(name) {
        let breadcrumbsMap = _.mapValues(this.props.breadcrumbs, 'name'),
            currentPath = _.toArray(breadcrumbsMap).toString(),
            path_value = currentPath + ',' + name;

        let formData = new FormData();
        formData.append('path_value', path_value);//字串, 路徑的name, ex: root,folder1,folder2

        $.ajax({
            type: 'post',
            url: '/api/W_SaleSky_MediaCloud_Relation_Delete.php',
            data: formData,
            processData: false,
            contentType: false,
            success: response => {
                if (response.status === "554") {
                    alert('資料夾底下仍有檔案,無法刪除');
                }
                if (response.status === "0") {//成功              
                    $('#folderDiv' + this.props.folder.id).hide();//成功刪除的當下先隱藏, 按下"完成"後再重刷頁面
                }
            },
            error: (xhr, ajaxOptions, thrownError) => { }
        });
    }
    onClickEdit(event, data) {
        /*
            點選右鍵編輯資料夾, 目前API尚未完成
        */
    }
    render() {
        let {
            folder,
            onClickFolder,
            deleteMode,
        } = this.props;
        return (
            <div id={'folderDiv' + folder.id}>
                {
                    !deleteMode ?
                        <ContextMenuTrigger id={'folderDiv' + folder.id} holdToDisplay={1000}>
                            <FolderViewMode
                                onClickFolder={onClickFolder}
                                folder={folder} />
                        </ContextMenuTrigger>
                        :
                        <FolderDeleteMode
                            folder={folder}
                            deleteFolder={this.deleteFolder}
                            bindTarget={this} />
                }
                <ContextMenu id={'folderDiv' + folder.id}>
                    <MenuItem onClick={this.onClickEdit} data={{ folderId: folder.id }}>編輯</MenuItem>
                </ContextMenu>
            </div>
        );
        /*
            ContextMenuTrigger 點選右鍵顯示contextMenu
            要包裹在"欲點擊的物件"之外
            一個ContextMenuTrigger的id, 會對應到一個ContextMenu的id
        */
    }
}

export class BreadcrumbInstance extends React.Component {
    setCrumb(index, item) {
        /*
           index: 麵包屑的index
           item: 路徑的物件, 如{ id:1 ,name: root }
        */
        let breadcrumbs = this.props.breadcrumbs;
        if (index + 1 < breadcrumbs.length) {
            let elementsRemain = index + 1;
            let newBreadcrumbs = _.take(breadcrumbs, elementsRemain);
            this.returnDir(newBreadcrumbs, item.id);
            /*
              點選所在位置以上的index才會改變麵包屑, 例如在root>folder1>folder2>folder3, 按下folder3不會重讀頁面
              let elementsRemain = index+1;  保留幾個麵包屑, ex:點選folder2, 保留3個; 點選folder1, 保留2個
            */
        }
    }
    returnDir(newBreadcrumbs, id) {
        this.props.onClickCrumb(id, newBreadcrumbs);//回傳新的麵包屑
    }
    render() {
        let breadcrumbs = this.props.breadcrumbs;
        return (
            <Breadcrumb>
                {
                    breadcrumbs.map((item, index) => {
                        return <Breadcrumb.Item key={index} onClick={this.setCrumb.bind(this, index, item)}>
                            {item.name}
                        </Breadcrumb.Item>
                    })
                }
            </Breadcrumb>
        );
    }
}

export const SelectField = (props) => {
    /*
        required: 是否為必填, true會出現紅色星號
        stateName: 欲改變的state名稱
    */
    return (
        <FormGroup>
            {props.required ? <RequiredStar /> : null}
            <ControlLabel>{props.label}</ControlLabel>
            <FormControl
                componentClass="select"
                value={props.value}
                onChange={event => props.onChangeHandler(props.stateName, event)}>
                <option value="">請選擇</option>
                {
                    props.options.map((item, index) => {
                        return (
                            <option key={index} value={item.id} >{item.name}</option>
                        )
                    })
                }
            </FormControl>
        </FormGroup>
    );
}

export const FilterSelect = props => {
    /*
        左上角的顯示全部/pdf/圖片...
        stateName: 欲改變的state名稱
    */
    return (
        <FormControl
            id="contentFilter"
            componentClass="select"
            value={props.value}
            onChange={event => props.onChangeHandler(props.stateName, event)}>
            {
                props.options.map((item, index) => {
                    return (
                        <option key={index} value={item.value} >{item.name}</option>
                    )
                })
            }
        </FormControl>
    );
}

export const TextField = props => {
    /*
        required: 是否為必填, true會出現紅色星號
        stateName: 欲改變的state名稱
    */
    return (
        <FormGroup>
            {props.required ? <RequiredStar /> : null}
            <ControlLabel>{props.label}</ControlLabel>
            <FormControl
                type='text'
                value={props.value}
                onChange={event => props.onChangeHandler(props.stateName, event)}>
            </FormControl>
        </FormGroup>
    );
}

export const HintText = props => {
    /*
        錯誤提示訊息, hintText為字串
    */
    return <span className="hintText">{props.hintText}</span>;
}

export const SuccessMsg = props => {
    /*
        成功訊息, 綠色打勾動畫
        覺得很醜可以換掉
    */
    return (
        <div className="successMsg">
            <span>{props.successText}</span>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
        </div>
    );
}

export const RequiredStar = props => {
    //必填紅色星號
    return <span style={{ color: "red" }}>* </span>;
}

export const UploadingSpin = props => {
    /*
        檔案上傳中的橘色旋轉按紐
        因為老闆說, 若影片上傳需要一段時間, 要讓使用者知道正在"上傳中"
        覺得很醜可以換掉
    */
    return <span className="glyphicon glyphicon-upload glyphicon-upload-animate"></span>;
}

export class MultiSelectField extends React.Component {
    /*
        多選選單
    */
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            crazy: false,
        }
    }
    //    toggleDisabled (e) {
    // 	this.setState({ disabled: e.target.checked });
    // }
    render() {
        let {
            multiSelectOptions,//options
            multiSelectedValues,//已選擇的option
            onChange,
            label,
            enableEdit
        } = this.props;
        return (
            <FormGroup>
                <div className="section">
                    <ControlLabel>{label}</ControlLabel>
                    <Select
                        multi
                        simpleValue
                        // disabled={this.state.disabled}
                        value={multiSelectedValues}
                        placeholder="請選擇"
                        options={multiSelectOptions}
                        onChange={onChange}
                        disabled={!enableEdit}
                    />
                </div>
            </FormGroup>
        );
    }
}

export const PolicySelectField = ({ onChangeHandler, value, enableEdit, helpText }) => {
    /*
      權限選單
    */
    return (
        <FormGroup>
            <ControlLabel>全部/部分 開放{helpText ? <span style={{ color: 'red' }}> {helpText}</span> : ''}</ControlLabel>
            <FormControl
                componentClass="select"
                value={value}
                onChange={event => onChangeHandler('all_policy', event)}
                disabled={!enableEdit}
            >
                <option value="1">全部</option>
                <option value="0">部分</option>
            </FormControl>
        </FormGroup>
    );
}

export const FileContent = props => {
    /*
        顯示檔案files
        deleteMode: 是否為刪除模式
        breadcrumbs: 麵包屑
        reload: 重刷頁面的function
        editFile: 編輯檔案的function, 顯示編輯的modal
    */
    let files = props.files;
    return (
        <div>
            {
                files.map((item, index) => {
                    return <div key={index}>
                        <AFile
                            file={item}
                            deleteMode={props.deleteMode}
                            breadcrumbs={props.breadcrumbs}
                            reload={props.reload}
                            editFile={props.editFile} />
                    </div>
                })
            }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/salesky/routes/news/news_common_component.jsx